export default __webpack_public_path__ + "static/media/case_1.e0f64462.png";